module.exports = __webpack_public_path__ + "img/15.e0913cce.png";